export default "__VITE_ASSET__BoMvA$yz__"